import React, { useState } from "react"
import { Button, Card, CardContent, Divider, Stack, Typography } from "@mui/material"
import UpgradeDialog from "@/features/billing/components/UpgradeDialog"
import { FREE_TRIAL_CREDITS } from "@/shared/constants/plans"

interface CreditCardProps {
  creditsRemaining: number
  creditsUsed: number
  creditsPurchased: number
}

const CreditCard: React.FC<CreditCardProps> = ({ creditsRemaining, creditsUsed, creditsPurchased }) => {
  const [upgradeOpen, setUpgradeOpen] = useState(false)

  const isFreeTrial = creditsPurchased === 0

  return (
    <>
      <Card variant="outlined" sx={{ borderRadius: 3, height: "100%", width: "100%" }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6" fontWeight={700}>
              Image Credits
            </Typography>
            <Divider />

            <Stack spacing={0.5}>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Credits remaining
                </Typography>
                <Typography variant="body2" fontWeight={700}>
                  {creditsRemaining}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="body2" color="text.secondary">
                  Credits used
                </Typography>
                <Typography variant="body2">{creditsUsed}</Typography>
              </Stack>
              {!isFreeTrial && (
                <Stack direction="row" justifyContent="space-between">
                  <Typography variant="body2" color="text.secondary">
                    Total purchased
                  </Typography>
                  <Typography variant="body2">{creditsPurchased}</Typography>
                </Stack>
              )}
              {isFreeTrial && (
                <Typography variant="body2" color="text.secondary" pt={0.5}>
                  Free trial — {FREE_TRIAL_CREDITS} images included, no credit card required.
                </Typography>
              )}
            </Stack>

            <Button variant="contained" fullWidth onClick={() => setUpgradeOpen(true)}>
              Buy More Credits
            </Button>
          </Stack>
        </CardContent>
      </Card>

      <UpgradeDialog open={upgradeOpen} onClose={() => setUpgradeOpen(false)} />
    </>
  )
}

export default CreditCard
